import React from "react";
import "../styles/Testimonials.css";

const testimonialsData = [
  {
    id: 1,
    name: "Leandro",
    image: "/assets/leandro.png",
    text: "Desde que adotamos o RondaGO, nossa operação ficou muito mais eficiente!",
  },
  {
    id: 2,
    name: "Roberto",
    image: "/assets/roberto.png",
    text: "A gestão do condomínio nunca foi tão simples e organizada.",
  },
  {
    id: 3,
    name: "Mariana",
    image: "/assets/mariana.png",
    text: "Agora posso focar em melhorias, pois a operação está sempre sob controle.",
  },
  {
    id: 4,
    name: "Gustavo",
    image: "/assets/gustavo.png",
    text: "O RondaGO trouxe tranquilidade para nossa equipe e moradores.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials">
      <h2>O que nossos clientes dizem</h2> {/* 🔹 Mantém a hierarquia dentro da Home */}
      <p style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}>
        Veja como o RondaGO tem transformado a gestão de condomínios e facilitado a vida de síndicos e administradores.
      </p>

      <div className="testimonials-grid">
        {testimonialsData.map((testimonial) => (
          <div className="testimonial-item" key={testimonial.id}>
            <img src={testimonial.image} alt={testimonial.name} className="testimonial-image" />
            <p>{testimonial.text}</p>
            <h3>{testimonial.name}</h3> {/* 🔹 Nome do cliente agora está em <h3> */}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
